import { ReactNode } from "react";

interface PageHeaderProps {
  title: string;
  description?: string;
  children?: ReactNode;
  className?: string;
}

const PageHeader = ({ title, description, children, className = "" }: PageHeaderProps) => {
  return (
    <div className={`bg-gradient-to-r from-medical-50 to-medical-100/50 py-16 md:py-24 ${className}`}>
      <div className="container mx-auto px-6 md:px-8">
        <div className="max-w-3xl mx-auto text-center space-y-4">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 opacity-0 animate-fade-in">
            {title}
          </h1>
          {description && (
            <p className="text-lg text-gray-600 opacity-0 animate-fade-in animate-delay-100">
              {description}
            </p>
          )}
          {children}
        </div>
      </div>
    </div>
  );
};

export default PageHeader;